<template>
  <svg :class="styling" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path d="M13.545 6.455c-.9-.9-2.17-1.481-3.545-1.481a4.934 4.934 0 0 0-3.545 1.481c-.9.9-1.481 2.17-1.481 3.545 0 1.376.582 2.646 1.481 3.545.9.9 2.17 1.481 3.545 1.481a4.934 4.934 0 0 0 3.545-1.481c.9-.9 1.481-2.17 1.481-3.545a4.934 4.934 0 0 0-1.481-3.545zM10 3.413a.7.7 0 0 0 .688-.688V.688A.7.7 0 0 0 10 0a.7.7 0 0 0-.688.688v2.037a.7.7 0 0 0 .688.688zm5.635 1.931 1.455-1.455a.67.67 0 0 0 0-.952.67.67 0 0 0-.952 0l-1.455 1.455a.67.67 0 0 0 0 .952c.238.264.66.264.952 0zm3.677 3.968h-2.037a.7.7 0 0 0-.688.688.7.7 0 0 0 .688.688h2.037A.7.7 0 0 0 20 10a.7.7 0 0 0-.688-.688zm-3.704 5.344a.67.67 0 0 0-.952 0 .67.67 0 0 0 0 .952l1.455 1.455a.67.67 0 0 0 .952 0 .67.67 0 0 0 0-.952l-1.455-1.455zM10 16.587a.7.7 0 0 0-.688.688v2.037A.7.7 0 0 0 10 20a.7.7 0 0 0 .688-.688v-2.037a.7.7 0 0 0-.688-.688zm-5.635-1.931L2.91 16.111a.67.67 0 0 0 0 .952.67.67 0 0 0 .952 0l1.455-1.455a.67.67 0 0 0 0-.952c-.238-.264-.66-.264-.952 0zM3.413 10a.7.7 0 0 0-.688-.688H.688A.7.7 0 0 0 0 10a.7.7 0 0 0 .688.688h2.037A.7.7 0 0 0 3.413 10zm.952-4.656a.67.67 0 0 0 .952 0 .67.67 0 0 0 0-.952L3.862 2.937a.67.67 0 0 0-.952 0 .67.67 0 0 0 0 .952l1.455 1.455z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  props: {
    styling: {
      type: String,
      default: 'w-6 h-6 text-red-600'
    }
  }

}
</script>

<style>

</style>